<template>
  <div class="business_descriptions">
    <a-descriptions
      bordered
      title=""
      size="small"
      layout="horizontal"
      :column="2"
    >
      <a-descriptions-item span="2">
        <template slot="label"> 期末累计投资总额 </template>
        <el-input v-if="!disabled" v-model="addFormInfo['finalInvestAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["finalInvestAmount"] }} {{ addFormInfo["finalInvestAmount"]?'万元':'' }} </template>
      </a-descriptions-item>

      <a-descriptions-item span="2">
        <template slot="label"> 期末累计运营费用 </template>
        <el-input
          v-if="!disabled"
          v-model="addFormInfo['finalOperationAmount']"
        >
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else
          >{{ addFormInfo["finalOperationAmount"] }}{{ addFormInfo["finalOperationAmount"]?'万元':'' }}</template
        >
      </a-descriptions-item>
      <a-descriptions-item span="2">
        <template slot="label"> 期末累计收益 </template>
        <el-input v-if="!disabled" v-model="addFormInfo['finalEarnings']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["finalEarnings"] }}{{ addFormInfo["finalEarnings"]?'万元':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 期末累计总投资项目个数: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['finalProjectCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["finalProjectCount"] }}{{ addFormInfo["finalProjectCount"]?'个':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 期末累计总投资项目总额: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['finalProjectAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["finalProjectAmount"] }}{{ addFormInfo["finalProjectAmount"]?'万元':'' }}</template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label"> 其中：在管项目个数: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['manageProjectCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["manageProjectCount"] }}{{ addFormInfo["manageProjectCount"]?'个':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 其中：在管项目总额: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['manageProjectAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["manageProjectAmount"] }}{{ addFormInfo["manageProjectAmount"]?'万元':'' }}</template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label"> 本期新增项目个数 </template>
        <el-input v-if="!disabled" v-model="addFormInfo['newProjectCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["newProjectCount"] }}{{ addFormInfo["newProjectCount"]?'个':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 本期新增项目总额: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['newProjectAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["newProjectAmount"] }}{{ addFormInfo["newProjectAmount"]?'万元':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 已退出项目个数: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['quitProjectCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["quitProjectCount"] }}{{ addFormInfo["quitProjectCount"]?'个':'' }}</template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label"> 已退出项目总额 </template>
        <el-input v-if="!disabled" v-model="addFormInfo['quitProjectAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["quitProjectAmount"] }}{{ addFormInfo["quitProjectAmount"]?'万元':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 已上市项目个数: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['marketProjectCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["marketProjectCount"] }}{{ addFormInfo["marketProjectCount"]?'个':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 已上市项目总额: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['marketProjectAmout']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["marketProjectAmout"] }}{{ addFormInfo["marketProjectAmout"]?'万元':'' }}</template>
      </a-descriptions-item>

      <a-descriptions-item>
        <template slot="label"> 期末累计总投资基金个数: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['fundCount']">
          <template slot="append"> 个 </template>
        </el-input>
        <template v-else>{{ addFormInfo["fundCount"] }}{{ addFormInfo["fundCount"]?'个':'' }}</template>
      </a-descriptions-item>
      <a-descriptions-item>
        <template slot="label"> 期末累计总投资基金总额: </template>
        <el-input v-if="!disabled" v-model="addFormInfo['fundAmount']">
          <template slot="append"> 万元 </template>
        </el-input>
        <template v-else>{{ addFormInfo["fundAmount"] }}{{ addFormInfo["fundAmount"]?'万元':'' }}</template>
      </a-descriptions-item>

      <a-descriptions-item span="2">
        <template slot="label"> 管理费收取情况 </template>
        <div class="">
          <WordUpload
            v-if="!disabled"
            @showFileName="(el) => showFile(el, 'manageExpenseFileList')"
            baFileMenuId="1596024094191628290"
            :id="id"
            :plain="false"
            :tip="false"
            :readonly="false"
          />
          <template v-for="(item, index) in manageExpenseFileList">
            <div class="file_wrapper" :key="index">
              <a
                class="file_button"
                target="_blank"
                :href="
                  isWord(item.fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                      item.fileUrl
                    : item.fileUrl
                "
                type="text"
                size="small"
              >
                {{ item.fileName }}
              </a>
              <i
                @click="downLoadFile(item.id)"
                class="el-icon-download del_icon"
              ></i>
              <i
                v-if="!disabled"
                @click="delFile(item.id, index, 'manageExpenseFileList')"
                class="el-icon-circle-close del_icon"
              ></i>
            </div>
          </template>
        </div>
      </a-descriptions-item>
      <a-descriptions-item span="2">
        <template slot="label"> 基金利润分配情况 </template>
        <div class="">
          <WordUpload
            @showFileName="(el) => showFile(el, 'profitFileList')"
            baFileMenuId="1596024118547951618"
            :id="id"
            :plain="false"
            :tip="false"
            :readonly="false"
            v-if="!disabled"
          />
          <template v-for="(item, index) in profitFileList">
            <div class="file_wrapper" :key="index">
              <a
                class="file_button"
                target="_blank"
                :href="
                  isWord(item.fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                      item.fileUrl
                    : item.fileUrl
                "
                type="text"
                size="small"
              >
                {{ item.fileName }}
              </a>
              <i
                @click="downLoadFile(item.id)"
                class="el-icon-download del_icon"
              ></i>
              <i
                v-if="!disabled"
                @click="delFile(item.id, index, 'profitFileList')"
                class="el-icon-circle-close del_icon"
              ></i>
            </div>
          </template>
        </div>
      </a-descriptions-item>

      <a-descriptions-item span="2">
        <template slot="label"> 合伙人会议召开情况 </template>
        <div class="">
          <WordUpload 
             v-if="!disabled"
            @showFileName="(el) => showFile(el, 'meetFileList')"
            baFileMenuId="1596024144447778817"
            :id="id"
            :plain="false"
            :tip="false"
            :readonly="false"
          />
          <template v-for="(item, index) in meetFileList">
            <div class="file_wrapper" :key="index">
              <a
                class="file_button"
                target="_blank"
                :href="
                  isWord(item.fileUrl)
                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                      item.fileUrl
                    : item.fileUrl
                "
                type="text"
                size="small"
              >
                {{ item.fileName }}
              </a>
              <i
                @click="downLoadFile(item.id)"
                class="el-icon-download del_icon"
              ></i>
              <i
                v-if="!disabled"
                @click="delFile(item.id, index, 'meetFileList')"
                class="el-icon-circle-close del_icon"
              ></i>
            </div>
          </template>
        </div>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import WordUpload from "@/components/wordUpload/wordUpload";
import * as dictionaries from "@/api/zd/dictionaries";
import { downLoadTemplate, downLoadTemplateGet } from "@/router/downLoadTem";

export default {
  name: "businessDescriptions",
  data() {
    return {
      addFormInfo: {},
      manageExpenseFileList: [],
      profitFileList: [],
      meetFileList: [],
    };
  },
  watch: {
    bindData: {
      handler(newData, oldData) {
      
        let addFormInfo = JSON.parse(JSON.stringify(newData));
        this.addFormInfo = addFormInfo;

      },
      deep:true,
      immediate:true
    },
    "$route.params.id": {
      immediate: true,
      handler(newVal) {
        let dataList = [
          {
            baFileMenuId: "1596024094191628290", //管理费收取情况
            name: "manageExpenseFileList",
          },
          {
            baFileMenuId: "1596024118547951618", //基金利润分配情况
            name: "profitFileList",
          },
          {
            baFileMenuId: "1596024144447778817", //合伙人会议召开情况
            name: "meetFileList",
          },
        ];
        dataList.map((item) => {
          this.findFileByOtherId(newVal, item.baFileMenuId, item.name);
        });
      },
    },
  },
  props: {
    id: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 传入的详细数据
    bindData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    WordUpload,
    downLoadTemplate,
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },
  mounted() {},
  methods: {
    findFileByOtherId(id, baFileMenuId, name) {
      dictionaries
        .findFileByOtherId({
          fileOtherId: id,
          baFileMenuId: baFileMenuId,
        })
        .then((res) => {
          this[name] = res.data.data;
        })
        .catch((res) => {});
    },

    //上传附件回显
    showFile(data, name) {
      this[name] = data;
    },
    downLoadFile(id) {
      downLoadTemplate("/api/file/down", {
        id,
      }).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
    //删除附件
    delFile(fileId, index, name) {
      this.$confirm("确定将附件删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return dictionaries.deleteFile({
            fileId,
          });
        })
        .then(() => {
          this[name].splice(index, 1);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.ant-descriptions-item-label {
  background-color: #F6FAFF;
}
.business_descriptions {
  background: #fff;
  margin-bottom: 20px;
  margin-top: 20px;
}
/deep/ .el-input-number {
  width: 100%;
  text-align: left;
}
/deep/ .el-input__inner {
  text-align: left;
}
/deep/.el-date-editor.el-input {
  width: 100%;
}
.word_upload {
  display: inline-block;
  width: auto;
}
/deep/ .ant-descriptions-view {
  border :1px solid #e0eeff
}
</style>